import { render, staticRenderFns } from "./FlatSelector.vue?vue&type=template&id=5f2f4f65&"
import script from "./FlatSelector.vue?vue&type=script&lang=js&"
export * from "./FlatSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports